import { ComposeFormStateContextValue, ComposeRecipientsContextValue, ComposeClientContextValue, ComposeEmailFormatContextValue } from "@/lib/core/crm/types";
import { ComposeTab } from "@/lib/types/compose-modal-types";

export const getFormStateValue = (composeForm: any): ComposeFormStateContextValue => ({
  form: composeForm.form,
  activeTab: composeForm.activeTab,
  hasUnfilledVariables: composeForm.hasUnfilledVariables,
  variableValues: composeForm.variableValues,
  showVariablePreview: composeForm.showVariablePreview,
  watchedSubject: composeForm.watchedSubject,
  watchedBody: composeForm.watchedBody,
  onTabChange: (tab: ComposeTab) => composeForm.setActiveTab(tab),
  onVariableUpdate: composeForm.handleVariableUpdate,
  onToggleVariablePreview: () =>
    composeForm.setShowVariablePreview(!composeForm.showVariablePreview),
});

export const getRecipientsStateValue = (composeForm: any): ComposeRecipientsContextValue => ({
  recipients: composeForm.recipients,
  ccRecipients: composeForm.ccRecipients,
  bccRecipients: composeForm.bccRecipients,
  ccBccMode: composeForm.ccBccMode,
  onRecipientsChange: composeForm.setRecipients,
  setCcBccMode: composeForm.setCcBccMode,
  setCcRecipients: composeForm.setCcRecipients,
  setBccRecipients: composeForm.setBccRecipients,
});

export const getClientStateValue = (composeForm: any): ComposeClientContextValue => ({
  selectedClient: composeForm.selectedClient,
  clientOptions: composeForm.clientOptions,
  filteredHubUsers: composeForm.filteredHubUsers,
  hubUsersLoading: composeForm.hubUsersLoading,
  clientsLoading: composeForm.clientsLoading,
  isSearching: composeForm.isSearching,
  clientSearchTerm: composeForm.clientSearchTerm,
  existingContact: composeForm.existingContact,
  personalizationOrigin: composeForm.personalizationOrigin,
  onClientSelect: composeForm.handleClientSelect,
  onClientSearchChange: composeForm.setClientSearchTerm,
});

export const getEmailFormatStateValue = (): ComposeEmailFormatContextValue => ({
  emailFormat: "plain",
  htmlEmailData: { to: "", subject: "", body: "" },
  htmlValidationErrors: [],
  onEmailFormatChange: () => {},
  onHtmlEmailChange: () => {},
});
